import { render, staticRenderFns } from "./WishlistModal.vue?vue&type=template&id=71441a89&scoped=true"
import script from "./WishlistModal.vue?vue&type=script&lang=js"
export * from "./WishlistModal.vue?vue&type=script&lang=js"
import style0 from "./WishlistModal.vue?vue&type=style&index=0&id=71441a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71441a89",
  null
  
)

export default component.exports